import { SVG, SVGProps } from './svg'

export function IconArrowDownShort(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M12.5 3c.28 0 .5.22.5.5v14.17l6.44-6.45a.5.5 0 0 1 .71 0l.7.71a.5.5 0 0 1 0 .71l-8.13 8.14a.75.75 0 0 1-.53.22h-.38a.77.77 0 0 1-.53-.22l-8.13-8.14a.5.5 0 0 1 0-.71l.71-.71a.49.49 0 0 1 .7 0L11 17.67V3.5c0-.28.22-.5.5-.5h1Z" />
    </SVG>
  )
}
